<template>
  <b-container fluid class="dprojects">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          All Projects
          <span class="addBtn" v-on:click="goToAddProject"> + Add Project</span>
        </div>
      </b-col>
    </b-row>
    <b-row class="m-2">
      <b-col lg="12" md="12" sm="12" xs="12" class="box text-left mb-3 pb-3" v-for="(project, index) in projectList" :key="index">
        <b-row>
          <b-col lg="3" md="3" sm="12" xs="12">
            <img v-if="project.attributes.images != null && project.attributes.images.data != null" :src="getImage(project.attributes.images.data[0].attributes.url, 'url')">
          </b-col>
          <b-col lg="9" md="9" sm="12" xs="12">
            <div class="text-right">
              <div class="actionBtn" v-on:click="deleteProject(project)">Remove</div>
              <div class="actionBtn" v-on:click="editProject(project.id)">Edit</div>
            </div>
            <div class="clearfix"></div>
            <div>Project : {{project.attributes.name}}</div>
            <div>Lokasi : {{project.attributes.city}}</div>
            <div>Deskripsi : {{project.attributes.description}}</div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="m-2" v-if="projectList.length < 1">
      <b-col lg="12" md="12" sm="12" xs="12" class="box text-left mb-3 pb-3">
        No project available yet.
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'DProjects',
  data () {
    return {
      projectSection: 'projects',
      projectList: []
    }
  },
  methods: {
    goToAddProject () {
      this.$router.push('/addproject')
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    editProject (id) {
      this.$router.push({name: 'EditProject', params: {id: id}})
    },
    deleteProject (project) {
      this.isLoading = true
      this.$store.dispatch('deleteProject', {
        data: {
          id: project.id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.deleteFile(project.attributes.images.data[0].id)
        },
        fail: () => {
          this.toast('Could not remove project. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    deleteFile (id) {
      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.toast('Remove project is done.', 'success', 'check')
          this.findAllProjects(0)
        },
        fail: () => {
          this.toast('Image delete failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllProjects (page) {
      this.isLoading = true
      this.$store.dispatch('getProjectList', {
        success: (res) => {
          this.$data.projectList = res.body.data
        },
        fail: () => {
          this.toast('Could not get projects. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  },
  created () {
    this.findAllProjects(0)
  },
  computed: {
    ...mapGetters([
      'projects'
    ])
  }
}
</script>

<style scoped>
.dprojects {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  border-bottom: 1px solid #BDBDBD;
}
.box img {
  width: 100%;
}
.actionBtn {
  float:right;
  margin-top: 5px;
  margin-left: 15px;
  color: #455A64;
}
.actionBtn:hover {
  cursor: pointer;
  color: #000;
  text-decoration: underline;
}
.addBtn {
  background-color: #FF8F00;
  padding: 5px 25px;
  text-transform: capitalize;
  margin-left: 50px;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.addBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DProjects.vue